module.exports = __webpack_public_path__ + "img/3.7553d683.png";